import "./checkbox.css";

type CheckBoxType = "checkbox" | "switchbox";

export interface CheckBoxProps {
	id: string,
	text: string,
	onChecked?: (value: boolean) => void,
	checked?: boolean,
	type?: CheckBoxType
}

function CheckBox(props: CheckBoxProps) {
	const cls = props.type === "switchbox" ? "form-check form-switch" : "form-check";

	return (
		<div className={cls}>
			<input className="form-check-input" type="checkbox"
				id={props.id}
				role={props.type === "switchbox" ? "switch" : "checkbox"}
				onChange={(e) => {
					props.onChecked?.(e.currentTarget.checked);
				}}
				checked={props.checked} />
			<label className="form-check-label" htmlFor={props.id}>
				{props.text}
			</label>
		</div>
	);
}

export default CheckBox;